import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { reatomWallet, WalletId } from '@root/entities/wallet'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import { backOfficeWalletsRegistry } from '../back-office-wallet'

import type { DelugeId } from '@root/entities/user-short'

interface BackOfficeWalletRefreshBalancePayload {
  delugeId: DelugeId
  walletId: WalletId
}

export const reatomBackOfficeWalletRefreshBalanceRequestAction = action(
  async (ctx, data: BackOfficeWalletRefreshBalancePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.admin.adminWalletRefreshBalanceCreate, [
        data,
      ]),
    )

    return result.pipe(
      Result.map((dto) => {
        return backOfficeWalletsRegistry.mutateOrCreate({
          key: WalletId(dto.walletId),
          mutate: (wallet) => wallet.updateFromDto(ctx, dto),
          create: () => reatomWallet.create(ctx, dto),
        })
      }),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'reatomBackOfficeWalletRefreshBalanceRequestAction',
)
